import Web3Modal from "web3modal";
import { ethers } from "ethers";


const providerOptions = {
    binancechainwallet: {
        package: true,
    },
};

const web3Modal = (chain =56) => {
    return new Web3Modal({
        chainId: chain, // binance chain Id
        theme: "dark",
        cacheProvider: true,
        disableInjectedProvider: false,
        providerOptions,
    });
};

export const getProvider = async () => {
    const instance = await web3Modal().connect();
    return new ethers.providers.Web3Provider(instance);
};


 export const connectWallet = async () => {
    const provider = await getProvider();
    const account = await provider.listAccounts();
    localStorage.setItem("connected", Date.now());
    console.log(account[0]);
const walletAddress = account[0];
console.log(`Your address is: ${walletAddress}`)
return JSON.stringify(account[0]);
};

